/**
 * Permission vocabulary, as issued with the access token at login.
 *
 * A granted permission is identified by its `module` + `name` pair (e.g.
 * Organization + Create), and its menu is identified by the `menuType` id.
 * The backend's `code` field (`org:create`) is deliberately NOT used here —
 * it exists for the backend's own checks.
 */

/** `menuType` ids — the module a permission belongs to. */
export enum MenuType {
  Dashboard = 1,
  User = 2,
  Organization = 3,
  Role = 4,
  Policy = 5,
  Audit = 6,
  Masters = 7,
}

/** `module` values. */
export const PERMISSION_MODULE = {
  Dashboard: 'Dashboard',
  User: 'User',
  Organization: 'Organization',
  Role: 'Role',
  Policy: 'Policy',
  Audit: 'Audit',
  Masters: 'Masters',
} as const;

/** `name` values — the action within a module. */
export const PERMISSION_ACTION = {
  Create: 'Create',
  Read: 'Read',
  Update: 'Update',
  Delete: 'Delete',
  Invite: 'Invite',
  ManageRole: 'Manage Role',
  Unlock: 'Unlock',
  Verify: 'Verify',
} as const;

export type PermissionModule = (typeof PERMISSION_MODULE)[keyof typeof PERMISSION_MODULE];
export type PermissionAction = (typeof PERMISSION_ACTION)[keyof typeof PERMISSION_ACTION];
